<button (click)="onSelectFileClick()"
    matTooltip="Select A Backup File To Restore"
    mat-raised-button>Select File</button>